// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__Uwd9e","soft":"Pill_soft__MPwXN"};